
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('brand_list')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button class="btn btn-outline-primary btn-sm no-bor" @click="newHandler">
                <i class="fa fa-plus-circle"></i> {{$t('new')}}
            </button>
        </div>
        <div class="x_body">
            <div class="card n_card no-bor">
                <div class="card-body" style="padding: 0;">
                    <table class="table table-bordered table-sm no-bor" style="overflow-x: scroll">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('name') }}</th>
                            <th>{{ $t('description') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td><a href="javascript:void(0)" @click="editHandler(ret)">{{ret.Name}}</a></td>
                            <td>{{ret.Description}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <FormModal ref="form" v-on:done="doneHandler" :value="edit" />
    </div>
</template>
<script>
    import FormModal from "./Form.vue";
    export default {
        props: {},
        components: { FormModal },
        data: function() {
            return {
                query: {
                    currentPage: 1,
                    total: 0,
                    limit: 25
                },
                records: [],
                edit: {},
            };
        },
        created: function() {
            this.init();
        },
        methods: {
            init: function() {
                let loading = this.$loading.show();
                this.$api().post('brands').then(res => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            newHandler: function(){
                this.edit = {
                    Name: ''
                };
                this.$refs.form.$refs.innermodal.show();
            },
            editHandler: function(item) {
                this.isedit = true;
                this.edit = JSON.parse(JSON.stringify(item));
                this.$refs.form.$refs.innermodal.show();
            },
            doneHandler: function() {
                this.init();
            }
        }
    };
</script>
